"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const bignumber_js_1 = require("bignumber.js");
const XCRebase_1 = __importDefault(require("./XCRebase"));
class XCController {
    constructor(data) {
        this.data = data;
        this.historicalRebases = [];
        this.lastRebase = new XCRebase_1.default(this.data.lastRebase);
        if (this.data.historicalRebases) {
            this.loadHistoricalRebases(this.data.historicalRebases.map((r) => new XCRebase_1.default(r)));
        }
    }
    get address() {
        return this.data.id;
    }
    get epoch() {
        return this.lastRebase.epoch;
    }
    get supply() {
        return this.lastRebase.supply;
    }
    // TODO: convert this to binary search
    getSupplyOn(dt) {
        const ts = new bignumber_js_1.BigNumber(dt);
        for (let r = 0; r < this.historicalRebases.length - 1; r++) {
            const r1 = this.historicalRebases[r];
            const r2 = this.historicalRebases[r + 1];
            if (ts.gte(r1.timestamp) && ts.lt(r2.timestamp)) {
                return r1.supply;
            }
        }
        return this.supply;
    }
    loadHistoricalRebases(rebases) {
        for (const rebase of rebases) {
            this.historicalRebases.push(rebase);
        }
        this.historicalRebases = this.historicalRebases.sort((r1, r2) => r1.timestamp.comparedTo(r2.timestamp));
    }
}
exports.default = XCController;
//# sourceMappingURL=XCController.js.map